










import { Component, Vue, Prop } from "vue-property-decorator";
import MonitoringSummary from "./MonitoringSummary.vue";
import * as analysesService from "@/services/analyses/index";
import { AnalysisSummaryDTO } from "@/api/analyses/types";

@Component({
  name: "MonitoringSummaryController",
  components: {
    MonitoringSummary,
  },
})
export default class MonitoringSummaryController extends Vue {
  private summary: AnalysisSummaryDTO | null = null;

  private url: string = "";

  @Prop({ type: String, required: false, default:'SOY' })
  private cropType!: string;

  @Prop({ type: String, required: false, default: 'SUMMER' })
  private harvestSeason!: string;

  @Prop({ type: String, required: false })
  private pipelineVersion!: string;

  @Prop({ type: String, required: false })
  private cropIdVersion!: string;
  
  @Prop({ type: String, required: false })
  private yieldestVersion!: string;

  @Prop({ type: String, required: true })
  private uuid!: string;

  private async mounted() {
    await this.loadAnalysisSummary();
  }

  private async loadAnalysisSummary() {
    await analysesService.getAnalysisSummary(this.uuid, this.harvestSeason, this.cropType);
  }

  get summaryInfo() {
    return this.$store.state.analyses.analysisSummaryContext;
  }
}
